import { Navigate } from 'react-router-dom';
import { isAdminUser } from '../services/auth.service';

const AdminGuardComponent = ({ children }) => isAdminUser() ? children : <Navigate to="/" />;

export default AdminGuardComponent;